import "../App.css";
// import Header from "../component/header/index.jsx";
import Footer from "../component/footer/index.jsx";

function PrivacyPolicy() {
  return (
    <>
      <div className="App">
        <section className="creative-sec privacy privacy-creative-sec mb-0">
          <div className="container-1280 ">
            <div className="row">
              <div className="col-lg-12 pp-txt-d">
                <h2 className="white-color lg-txt col-lg-3">Privacy</h2>
                <img
                  className="col-lg-3"
                  src={require("../Assets/img/book-img.png")}
                  alt=""
                />
                <h2 className="white-color lg-txt col-lg-3">Policy</h2>
              </div>

              <div className="pp-txt-m">
                <h2 className="white-color">Privacy Policy</h2>
              </div>
            </div>
          </div>
        </section>
        <section className="privacy-text">
          <div className="container-1280">
            <p>
              Welcome to KingsCharts.io. This website is owned and operated by
              ZELTA TECH PRIVATE LIMITED, B-29-30, B-39-40, RICO Industrial
              Area, 22 Godown Industrial Area, Jaipur, Rajasthan -302001 India.
              By visiting our website and using the information, resources,
              services, products, and tools we provide, you understand and agree
              to accept and adhere to the terms and conditions stated in this
              policy (hereafter referred to as the 'User Agreement'), as well as
              the terms and conditions stated in our Privacy Policy (for more
              information, please see the Privacy Policy section below).
            </p>
            <br />
            <p>
              The Privacy Policy oversees the ways in which KingsCharts.io
              gathers, uses, maintains, and discloses information collected from
              users (singular “a user”) of the https://kingscharts.io/ website
              (“Site”). This privacy policy is applicable to the Site and all
              the products and services offered by King’s Charts.
            </p>
            <br />
            <h3>1. PERSONAL IDENTIFICATION INFORMATION</h3>
            <p>
              Personal identification information may be collected from Users in
              a variety of ways, including, but not limited to, when Users visit
              our site, register on the site, place an order, and in connection
              with other activities, services, features, or resources made
              available on our Site. Users may be asked for their name, email
              address, mailing address, and phone number, as appropriate.
              However, users may visit our Site anonymously. We will only
              collect personal identification information from Users if they
              voluntarily provide it to us. Users can always refuse to provide
              personal identification information, but doing so may prevent them
              from participating in certain Site-related activities.
            </p>
            <br />
            <h3>2. NON-PERSONAL IDENTIFICATION INFORMATION</h3>
            <p>
              When Users interact with our Site, we may collect non-personal
              identification information about them. Non-personal identification
              information may include the browser name, computer type, and
              technical information about Users' means of connection to our
              Site, such as the operating system and Internet service providers
              used, among other similar bodies of information.
            </p>
            <br />
            <h3>3. WEB BROWSER COOKIES</h3>
            <p>
              “Cookies" may be used on our site to improve the user experience.
              Cookies are placed on a user's hard drive by their web browser for
              record-keeping and sometimes to track information about them.
              Users can configure their web browser to refuse cookies or to
              notify them when cookies are sent. If they do, keep in mind that
              some parts of the Site may not work properly.
            </p>
            <br />
            <h3>4. Usage of Collected Information</h3>
            <p>
              King’s Charts may collect and use personal information from Users
              for the following reasons: To enhance customer service - The
              information you provide allows us to respond to your customer
              service and support requests more efficiently. To personalise user
              experience - We may use aggregate information to better understand
              how our Users as a group use the services and resources on our
              Site. To improve our Site - We may use the feedback you provide to
              improve our products and services. To process payments - We may
              use the information Users provide about themselves when placing an
              order solely to fulfil that order. We do not share this
              information with third parties unless it is absolutely necessary
              to provide the service. To run a promotion, contest, survey, or
              other Site feature - To send Users information about topics we
              believe they will find interesting. To send periodic emails - We
              may use the email address to send User information and order
              updates. It could also be used to respond to their inquiries,
              questions, or other requests. If User chooses to join our mailing
              list, they will receive emails with company news, updates, related
              product or service information, and so on. If at any point the If
              a user wishes to be removed from receiving future emails, we
              include detailed unsubscribe instructions at the bottom of each
              email, or the user may contact us through our Site.
            </p>
            <br />
            <h3>5. Protection of Collected Information</h3>
            <p>
              We use appropriate data collection, storage, and processing
              practises, as well as security measures, to protect your personal
              information, username, password, transaction information, and data
              stored on our Site from unauthorised access, alteration,
              disclosure, or destruction. The Site and its Users exchange
              sensitive and private data via an SSL-secured communication
              channel and is encrypted and protected with digital signatures. In
              order to provide the most secure environment for Users, our Site
              adheres to PCI vulnerability standards.
            </p>
            <br />
            <h3>6. SHARING PERSONAL INFORMATION</h3>
            <p>
              Third-party service providers may be used to assist us in
              operating our business and the Site, as well as to administer
              activities on our behalf, such as sending out newsletters or
              surveys. If you have given us permission, we may share your
              information with these third parties for those limited purposes.
            </p>
            <br />
            <h3>8. COMPLIANCE WITH MINOR’S ONLINE PRIVACY PROTECTION ACT </h3>
            <p>
              It is especially important to protect the privacy of those under
              age. As a result, we never collect or maintain information on our
              Site from those we know are under the age of 13, and no part of
              our website is designed to attract anyone under the age of 13.
            </p>
            <br />
            <h3>9. CHANGES TO THIS PRIVACY POLICY</h3>
            <p>
              KingsCharts.io reserves the right to modify this privacy statement
              at any time. When we do, we will notify you via email however. We
              encourage Users to check this page frequently for changes to stay
              informed about how we are assisting in the protection of the
              personal information we collect. You acknowledge and agree that it
              is your responsibility to review this privacy policy on a regular
              basis and be aware of any changes.
            </p>
            <br />
            <h3>10. GOVERNING LAW</h3>
            <p>
              This website is controlled by{" "}
              <span>ZELTA TECH PRIVATE LIMITED</span> from our offices located
              in the state of Rajasthan, India. All disputes will be subject to
              Jaipur jurisdiction.
            </p>
            <br />
            <h3>11. CONTACT US</h3>
            <p>
              If you have any questions about this Privacy Policy, the practices
              of this site, or your dealings with this site, please contact us
              at: hello@kingscharts.io.
            </p>
            <br />
            <p>
              <span>ZELTA TECH PRIVATE LIMITED</span> B-29-30, B-39-40, RIICO
              Industrial Area, 22 Godown Industrial Area, Jaipur, Rajasthan,
              India - 302001
            </p>
            <br />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
